export const generateTimeIntervals = (intervalMinutes: number): string[] => {
    const times: string[] = [];
    const totalMinutesInDay = 24 * 60;

    for (let minutes = 0; minutes < totalMinutesInDay; minutes += intervalMinutes) {
        const hours = Math.floor(minutes / 60);
        const minutesPastHour = minutes % 60;

        // Format with leading zeros
        const timeString = `${hours.toString().padStart(2, '0')}:${minutesPastHour
            .toString()
            .padStart(2, '0')}:00`;
        times.push(timeString);
    }

    // Add the last time of the day
    //  We can't use 24:00:00 as it will cause errors and backend treats it as 00:00:00 which is incorrect
    //  Also, various time fields get unset when the seconds are non-zero so we use 23:59:00 over 23:59:59
    times.push('23:59:00');

    return times;
};
